import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class BulkUnitWeightGamaCalculationMethodModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (BulkUnitWeightGamaCalculationMethodModel._instance == null) BulkUnitWeightGamaCalculationMethodModel._instance = new BulkUnitWeightGamaCalculationMethodModel(authManager);
        return BulkUnitWeightGamaCalculationMethodModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'geo-sections/bulk-unit-weight-gama-calculation-methods', 'geo-sections/bulk-unit-weight-gama-calculation-methods/codelist');

        this.entityName = 'geo-sections.BulkUnitWeightGamaCalculationMethod';
        this.privileges = {
            create: [["#admin"]],
            read: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"],["readGeotechData"]],
            update: [["#admin"]],
            delete: [["#admin"]],
        };

        this.label = 'Bulk Unit Weight Gama Calc Method';
        this.setLabel = 'Bulk Unit Weight Gama Calc Methods';

        this.browser = {
            name: 'default-geo-sections-bulkunitweightgamacalculationmethod-browser',
            moduleName: 'default-geo-sections-bulkunitweightgamacalculationmethod-browser',
            moduleTitle: 'Bulk Unit Weight Gama Calc Methods',
            moduleStateSlotName: 'default-geo-sections-bulkunitweightgamacalculationmethod-browser',
        };

        this.editor = {
            name: 'default-geo-sections-bulkunitweightgamacalculationmethod-editor',
            moduleName: 'default-geo-sections-bulkunitweightgamacalculationmethod-editor',
            moduleTitle: 'Bulk Unit Weight Gama Calc Method',
            moduleStateSlotName: 'default-geo-sections-bulkunitweightgamacalculationmethod-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'code',
                type: 'string',
                persistent: true,
                label: 'Code',
                required: true,
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'isDisabled',
                type: 'bool',
                persistent: true,
                label: 'Is Disabled',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
        ];

    }

}
